import YYPage from './page'

export default YYPage